import Proxy from '../Proxy';

class ApprovementListProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('zvonok-com', parameters);
  }

  ordersBase() {
    return this.submit('get', 'zvonok-com/orders/base/contacts');
  }

  sendOrdersBase(data) {
    return this.submit('put', 'zvonok-com/orders/base/contacts', data);
  }

  ordersBaseCleaners() {
    return this.submit('get', 'zvonok-com/orders/base/cleaners');
  }

  sendOrdersBaseCleaners(data) {
    return this.submit('put', 'zvonok-com/orders/base/cleaners', data);
  }
}

export default ApprovementListProxy;
